module.exports = __webpack_public_path__ + "star-black.png?1a062e53c707510a3a5f777dfd217683";